import { render, staticRenderFns } from "./_TotalCartSticky.vue?vue&type=template&id=13798f1d"
import script from "./_TotalCartSticky.vue?vue&type=script&lang=js"
export * from "./_TotalCartSticky.vue?vue&type=script&lang=js"
import style0 from "./_TotalCartSticky.vue?vue&type=style&index=0&id=13798f1d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports